import { useSelector } from "react-redux";
import * as nodeUtils from "../../abstract/controller/utils/nodeUtils";
import { getIsExtended } from "../../abstract/redux/slice/metaSlice";
import LabelSingle from "./LabelSingle";
import styles from "./Labels.module.scss";

function Labels({ node, readOnly, alignCenter }) {
  const _isExtended = useSelector(getIsExtended(nodeUtils.getUUID(node)));

  if (_isExtended && !readOnly) {
    return null;
  }

  const _label = nodeUtils.getLabel(node);

  if (!_label) {
    return null;
  }

  const _uuid = nodeUtils.getUUID(node);

  return (
    <div
      id={`labels-${_uuid}`}
      className={`${styles["labels"]} ${alignCenter ? styles["labels--center"] : ""}`}>
      {_label.map((e) => (
        <LabelSingle key={e} label={e} uuid={_uuid} />
      ))}
    </div>
  );
}

export default Labels;
